import axios from 'axios';

export async function desativaPedidos(cnpj) {
    const data = {
        teste: 'teste'
    };
    const config = {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': cnpj
        }
    };
    try {
        const resDesativaPedidos = await axios.post(
            `${process.env.VUE_APP_APIURL}/public/dasativaPedidos`,
            data,
            config
        );
        console.log(resDesativaPedidos)
        return true;
    } catch (error) {
        console.error("Erro ao desativar pedidos:", error);
        return false;
    }
}